<template>

</template>
<script>
    import { store } from '../store/index';
    export default {
        name: 'BookingIdle',
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            isInSession() {
                return this.booking != null && this.booking.legs != null && this.booking.legs.length
                    && this.booking.legs[0].confirmationNumber != undefined && this.booking.legs[0].confirmationNumber != null;
            }
        },
        data() {
            return {
                isDisplayingMessage: false,
            }
        },
        mounted() {
            let o = this;
            var inactivityTime = function () {
                var time;
                window.onload = resetTimer;
                // DOM Events
                document.onmousemove = resetTimer;
                document.onkeydown = resetTimer;

                function resetTimer() {
                    clearTimeout(time);
                    time = setTimeout(o.showAlert, 300000)
                }

                window.addEventListener('load', resetTimer, true);

              
                var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
                events.forEach(function (name) {
                    document.addEventListener(name, resetTimer, true);
                });

                resetTimer();
            };

            inactivityTime();
        },

        methods: {
            showAlert() {
                let o = this;
                if (this.isDisplayingMessage || !this.isInSession) {
                    return;
                }

                this.isDisplayingMessage = true;
                let timerInterval;

                this.$swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonColor: '#425261',
                    title: 'Are you still there?',
                    html:
                        'Your booking session will expire in <strong></strong> seconds.<br/><br/>Do you wish to continue?<br/>',
                    timer: 60000, //300000
                    didOpen: () => {
                        const content = this.$swal.getHtmlContainer();
                        const $ = content.querySelector.bind(content);

                 
                        timerInterval = setInterval(() => {
                            this.$swal.getHtmlContainer()
                                .querySelector('strong')
                                .textContent = (this.$swal.getTimerLeft() / 1000)
                                    .toFixed(0)
                        }, 100);
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
  
                    },

                }).then((result) => {

                    if (result.isConfirmed) {
                        this.$swal.increaseTimer(15000)
                        o.keepAlive();
                    } else {
                        o.clearSession();
                    }

                    this.isDisplayingMessage = false;
                    //keep alive
                    clearInterval(timerInterval)
                })
            },
            keepAlive() {
                if (this.session != null) {
                    store.dispatch("keepAlive").then(() => { }).catch(() => {
                        this.$router.push({ name: 'stay_start', query: { hasError: true } });

                    });
                }
            },
            clearSession() {

                if (this.session != null) {

                    store.dispatch("ignoreBooking").then(() => {
                        store.dispatch("clearPartialData").then(() => {
                            this.$router.push({ name: 'stay_start', query: { hasExpired: true }});
                        });
                    });

                }
                else {
                    store.dispatch("clearPartialData").then(() => {
                        this.$router.push({ name: 'stay_start', query: { hasExpired: true } });
                    });
                }


            }
        }
    }
</script>

<style scoped>
    .swal2-styled.swal2-confirm, .swal2-cancel.swal2-styled {
        text-transform: uppercase;
        font-weight: bold;
    }
</style>